import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

const MAX_STROCKE_DASHARRAY = 127;

const getStrokeDashaOffset = (value: number) => {
  return MAX_STROCKE_DASHARRAY - (MAX_STROCKE_DASHARRAY / 100) * value;
};

const getSize = (value: string | number): string => {
  return typeof value === 'string' ? value : `${value}px`;
};

export interface CircularProgressProps extends StandardProps<React.HTMLAttributes<HTMLSpanElement>> {
  size?: string | number;
  value?: number;
  variant?: 'determinate' | 'indeterminate';
  color?: 'inherit' | 'primary';
  strokeWidth?: number;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  className,
  variant = 'indeterminate',
  value,
  style,
  size = 40,
  color = 'inherit',
  strokeWidth = 3.6,
  ...restProps
}) => {
  const styles: React.CSSProperties = {
    width: getSize(size),
    height: getSize(size),
    ...style,
  };

  const circleStyles: React.CSSProperties = {};

  if (variant === 'determinate') {
    styles['transform'] = 'rotate(-90deg)';
    circleStyles['strokeDasharray'] = MAX_STROCKE_DASHARRAY;
    circleStyles['strokeDashoffset'] = `${getStrokeDashaOffset(value || 0)}px`;
  }

  return (
    <span className={cn('circular-progress', `${color}`, `${variant}`, className)} style={styles} {...restProps}>
      <svg className="circular-progress__icon" viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth={strokeWidth} style={circleStyles}></circle>
      </svg>
    </span>
  );
};

export default CircularProgress;
